<div>
  @if (step === 'request') {
    <p class="mb-8 text-sm text-gray-500">Indique o número de telefone da conta. Enviaremos um PIN por SMS para a activar.</p>

    <form class="text-xs my-10" method="post" [formGroup]="form" (ngSubmit)="onRequestPin()">
      <app-phone-number-field>
        <app-text-input [formGroup]="form" type="number" id="phoneNumber" [maxLength]="9" [hideCounter]="true"
                        [value]="form.value?.phoneNumber"
                        label="Número de telefone"
                        [formError]="formErrors.get('phoneNumber')"></app-text-input>
      </app-phone-number-field>

      <div class="mt-6">
        <app-ae-button variant="primary" label="Enviar PIN" (buttonClick)="onRequestPin()"
                size="sm" styleClass="text-xs w-full"></app-ae-button>
      </div>
    </form>

    <p class="text-sm text-center text-gray-500">
      <button type="button" class="text-blue-500 focus:outline-none focus:underline hover:underline" (click)="showStep('confirm')">
        Já tenho o PIN
      </button>
    </p>
  } @else {
    <p class="mb-8 text-sm text-gray-500">Introduza o número de telefone e o PIN que recebeu por SMS para activar a conta.</p>

    <form class="text-xs my-10 space-y-8" method="post" [formGroup]="form" (ngSubmit)="onConfirmPin()">
      <app-phone-number-field>
        <app-text-input [formGroup]="form" type="number" id="phoneNumber" [maxLength]="9" [hideCounter]="true"
                        [value]="form.value?.phoneNumber"
                        label="Número de telefone"
                        [formError]="formErrors.get('phoneNumber')"></app-text-input>
      </app-phone-number-field>

      <div>
      <app-text-input [formGroup]="form" type="text" id="pin" [maxLength]="5" [hideCounter]="true"
                      [value]="form.value?.pin"
                      label="PIN"
                      [formError]="formErrors.get('pin')"></app-text-input>
      </div>

      <div class="mt-6">
        <app-ae-button variant="primary" label="Activar conta" (buttonClick)="onConfirmPin()"
                size="sm" styleClass="text-xs w-full"></app-ae-button>
      </div>
    </form>

    <p class="text-sm text-center text-gray-500">
      <button type="button" class="text-blue-500 focus:outline-none focus:underline hover:underline" (click)="showStep('request')">
        Pedir outro PIN
      </button>
    </p>
  }

  <p class="mt-6 text-sm text-center text-gray-500">Já possui conta?
    <a routerLink="/acesso" class="text-blue-500 focus:outline-none focus:underline hover:underline">
      Clique aqui para aceder!</a></p>
</div>
